export const request = async ({url, method = 'GET', body}) => {
  const response = await fetch(url, {
    headers: {
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`
    },
    method,
    body
  })
  if(!response.ok) {
    throw new Error(await response.json())
  }
  return await response.json()
}
